/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Series_5_30Inputs */

const en_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series of 5, 30 minute lessons`)
};

const es_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie de 5 clases de 30 minutos`)
};

const de_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie von 5 Golfstunden à 30 Minuten`)
};

const zh_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 次 30 分钟课程套餐`)
};

const ar_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلسلة من 5 دروس لمدة 30 دقيقة`)
};

const fr_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série de 5 leçons de 30 minutes`)
};

const vi_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói 5 buổi học 30 phút`)
};

const sw_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfululizo wa masomo 5 ya dakika 30`)
};

const th_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็ก 5 ครั้ง ครั้งละ 30 นาที`)
};

const bs_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serija od 5 časova po 30 minuta`)
};

const ja_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5回・30分レッスン`)
};

const ko_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5회 30분 레슨 시리즈`)
};

const pt_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote de 5 aulas de 30 minutos`)
};

const it_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie di 5 lezioni da 30 minuti`)
};

const sv_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie med 5 lektioner à 30 minuter`)
};

const nl_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reeks van 5 lessen van 30 minuten`)
};

const da_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie med 5 lektioner à 30 minutter`)
};

const nb_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakke med 5 leksjoner à 30 minutter`)
};

const fi_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 opetuskerran sarja (30 min)`)
};

const pl_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seria 5 lekcji po 30 minut`)
};

const ru_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серия из 5 уроков по 30 минут`)
};

const tr_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 adet 30 dakikalık ders paketi`)
};

const hi_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 पाठों की श्रृंखला, प्रत्येक 30 मिनट`)
};

const id_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seri 5 pelajaran 30 menit`)
};

const ms_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siri 5 pelajaran, 30 minit`)
};

const cs_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série 5 lekcí po 30 minutách`)
};

const el_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σειρά 5 μαθημάτων των 30 λεπτών`)
};

const he_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סדרה של 5 שיעורים של 30 דקות`)
};

const af_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reeks van 5 lesse van 30 minute`)
};

const hu_prices_label_series_5_30 = /** @type {(inputs: Prices_Label_Series_5_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 alkalmas, 30 perces bérlet`)
};

/**
* | output |
* | --- |
* | "Series of 5, 30 minute lessons" |
*
* @param {Prices_Label_Series_5_30Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_series_5_30 = /** @type {((inputs?: Prices_Label_Series_5_30Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Series_5_30Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_series_5_30(inputs)
	if (locale === "de") return de_prices_label_series_5_30(inputs)
	if (locale === "zh") return zh_prices_label_series_5_30(inputs)
	if (locale === "ar") return ar_prices_label_series_5_30(inputs)
	if (locale === "fr") return fr_prices_label_series_5_30(inputs)
	if (locale === "vi") return vi_prices_label_series_5_30(inputs)
	if (locale === "sw") return sw_prices_label_series_5_30(inputs)
	if (locale === "th") return th_prices_label_series_5_30(inputs)
	if (locale === "bs") return bs_prices_label_series_5_30(inputs)
	if (locale === "ja") return ja_prices_label_series_5_30(inputs)
	if (locale === "ko") return ko_prices_label_series_5_30(inputs)
	if (locale === "pt") return pt_prices_label_series_5_30(inputs)
	if (locale === "it") return it_prices_label_series_5_30(inputs)
	if (locale === "sv") return sv_prices_label_series_5_30(inputs)
	if (locale === "nl") return nl_prices_label_series_5_30(inputs)
	if (locale === "da") return da_prices_label_series_5_30(inputs)
	if (locale === "nb") return nb_prices_label_series_5_30(inputs)
	if (locale === "fi") return fi_prices_label_series_5_30(inputs)
	if (locale === "pl") return pl_prices_label_series_5_30(inputs)
	if (locale === "ru") return ru_prices_label_series_5_30(inputs)
	if (locale === "tr") return tr_prices_label_series_5_30(inputs)
	if (locale === "hi") return hi_prices_label_series_5_30(inputs)
	if (locale === "id") return id_prices_label_series_5_30(inputs)
	if (locale === "ms") return ms_prices_label_series_5_30(inputs)
	if (locale === "cs") return cs_prices_label_series_5_30(inputs)
	if (locale === "el") return el_prices_label_series_5_30(inputs)
	if (locale === "he") return he_prices_label_series_5_30(inputs)
	if (locale === "af") return af_prices_label_series_5_30(inputs)
	if (locale === "hu") return hu_prices_label_series_5_30(inputs)
	return en_prices_label_series_5_30(inputs)
});